import { ConfirmModal, Toasts, useModalContext } from '@fourthwall/components';
import { useSubscriptionOffers } from '../../modules/Subscriptions';
import { useStatusMutation } from './useStatusMutation';
export const useUnarchiveProduct = () => {
    const { open } = useModalContext();
    const { shouldShowLimitsModal, shouldShowUpgradeModal, openSubscriptionOffersLimitModal, openSubscriptionOffersUpgradeModal, } = useSubscriptionOffers();
    const { statusMutation } = useStatusMutation();
    const openUnarchiveProductModal = ({ name, id, onSuccess, onError, }) => {
        if (shouldShowLimitsModal) {
            openSubscriptionOffersLimitModal();
            return;
        }
        if (shouldShowUpgradeModal) {
            openSubscriptionOffersUpgradeModal({
                source: 'unarchive_product',
            });
            return;
        }
        open(ConfirmModal, {
            title: `Are you sure that you want to unarchive ${name}?`,
            confirmLabel: 'Unarchive',
            confirmAppearance: 'destructive',
            onConfirm: () => {
                statusMutation.mutate({ offerId: id, params: { status: 'PUBLIC' } }, {
                    onSuccess,
                    onError: (error) => {
                        Toasts.notify(error.message, { type: 'error' });
                        onError?.(error);
                    },
                });
            },
        });
    };
    return {
        openUnarchiveProductModal,
    };
};
